import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Promo codes',
  tabs: {
    active: 'Active',
    expired: 'Expired',
    email_sign_up: 'Promo email sign up',
  },
  show_master_promo_code: 'Show master promo code to customers',
  send_rejected_order_apologies_promo_code: 'Send promo code to customers when order is manually rejected',
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Master',
        [PromoCodeTag.Campaign]: 'Campaign',
        [PromoCodeTag.OneTime]: 'One Time',
      },
    },
    code: {
      placeholder: 'Code',
    },
    campaign: {
      placeholder: 'Campaign',
    },
    created_by: {
      placeholder: 'Created by',
      options: {
        [PromoCodeCreatedBy.User]: 'User',
        [PromoCodeCreatedBy.System]: 'System',
      },
    },
  },
  fields: {
    code: 'Code',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Discount type',
    discount: 'Discount',
    usage_threshold: 'Usage threshold',
    quantity: 'Quantity',
    expires_at: 'Expires',
    level: 'Level',
    max_discount: 'Max discount',
    created_by: 'Created by',
    image: 'Image',
  },
  tags: {
    [PromoCodeTag.Master]: 'Master',
    [PromoCodeTag.Campaign]: 'Campaign',
    [PromoCodeTag.OneTime]: 'One Time',
  },
  types: {
    single_use: 'Single use',
    multi_use: 'Multi use',
    unknown: 'Unknown',
  },
  discount_types: {
    fixed_amount: 'Fixed amount',
    percentage: 'Percentage',
    unknown: 'Unknown',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'User',
    [PromoCodeCreatedBy.System]: 'System',
  },
  labels: {
    discount: 'Discount',
    usage_threshold: 'Usage threshold',
    company: 'Company',
    restaurant: 'Restaurant',
    restaurant_group: 'Brand',
  },
  buttons: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    restore: 'Restore',
    add_promo_code: 'Add promo code',
    images: 'Manage image',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_save_settings: 'Failed to save the changes',
    failed_to_delete_promo_code: 'Failed to delete promo code',
    failed_to_restore_promo_code: 'Failed to restore promo code',
    promo_code_got_deleted: 'Promo code got deleted',
    promo_code_got_restored: 'Promo code got restored',
  },
  delete_confirmation: {
    title: 'Delete promo code?',
    buttons: {
      yes: 'Yes',
      no: 'No',
    },
  },
  restore_confirmation: {
    title: 'Restore promo code?',
    buttons: {
      yes: 'Yes',
      no: 'No',
    },
  },
};
